import styled from 'styled-components';
import InternalLink from 'components/InternalLink';
import colors from 'constants/colors';
import { labelText, touchableText } from 'constants/globalStyles';

const Wrapper = styled.div`
  position: relative;
  max-width: 328px;

  @media screen and (max-width: 992px) {
    margin: 24px 0;
  }
`;

const TitleRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
`;

const Title = styled.h3`
  ${labelText};
  margin: 0;
  color: ${colors.main.black};
`;

const Week = styled.div`
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 40px));
  gap: 8px;
`;

const Day = styled.button<{ active?: boolean }>`
  ${touchableText};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  aspect-ratio: 1;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: ${(props) => (props.active ? colors.main.fandango : colors.main.dividers)};
  color: ${(props) => (props.active ? colors.main.white : colors.main.black)};
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    opacity: 0.85;
  }

  &:focus-visible {
    outline: 2px solid ${colors.main.blue};
    outline-offset: 2px;
  }
`;

const CalendarRow = styled.div`
  margin-top: 20px;
`;

const ProgramLink = styled(InternalLink)`
  display: inline-block;
  font-size: 16px;
  padding-bottom: 16px;
  max-width: 256px;
`;

export { Wrapper, TitleRow, Title, Week, Day, CalendarRow, ProgramLink };
